export const getCostsByPlanAndUnits = (plan, units, paymentInterval, useDecimalPlaces = false) => {
	/**
	 * Note: All costs are annualized
	 */

	const unitCosts = plan.units.find((step) => step.units === units).price;

	const pricePerUnit = (plan.base_costs + unitCosts) / units;

	const prices = {
		annually: {
			// Determine the base cost of the plan
			plan: plan.base_costs,
			// Determine the cost of the units
			units: unitCosts,
			// Determine the price per unit
			perUnit: useDecimalPlaces ? roundTwoDecimals(pricePerUnit) : Math.ceil(pricePerUnit),
			// Determine the total cost of the plan
			total: plan.base_costs + unitCosts,
		},
	};

	// Calculate the monthly prices based on the annual prices
	prices.monthly = {};
	for (const key in prices.annually) {
		const pricePerMonth = getPricePerMonth(prices.annually[key], plan.monthly_surcharge, paymentInterval);
		prices.monthly[key] = useDecimalPlaces ? roundTwoDecimals(pricePerMonth) : Math.ceil(pricePerMonth);
	}

	return prices;
};

export const getPricePerMonth = (price, monthlySurcharge, paymentInterval) => {
	// If the payment interval is annually, divide the price by 12
	// If the payment interval is monthly, add the monthly surcharge to the price
	if (paymentInterval === 'annually') {
		return price / 12;
	} else {
		const monthly = price / 12;
		const surcharge = monthly * (monthlySurcharge / 100);
		return monthly + surcharge;
	}
};

export const getPackageCosts = (consultingPackage, state, paymentInterval, useDecimalPlaces = false) => {
	if (state === 'included') {
		return 0;
	} else if (consultingPackage.cost_type === 'one-time' || paymentInterval === 'annually') {
		return consultingPackage.price;
	} else {
		const pricePerMonth = consultingPackage.price / 12;
		return useDecimalPlaces ? roundTwoDecimals(pricePerMonth) : Math.ceil(pricePerMonth);
	}
};

export const roundTwoDecimals = (number) => Math.round(number * 100) / 100;

export const getLocalizedPrice = (price, currency, locale) => {
	const isInt = price % 1 === 0;
	return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: isInt ? 0 : 2 }).format(price);
};
